export function checkIsPrepareChildField(id: number | string): boolean {
  return String(id).startsWith('prepare');
}
